export var TestId;
(function (TestId) {
    TestId["LI_ELEMENT"] = "LI_ELEMENT";
    TestId["EXPAND_BUTTON"] = "EXPAND_BUTTON";
    TestId["UL_ELEMENT"] = "UL_ELEMENT";
    TestId["LEFT_CONTAINER"] = "LEFT_CONTAINER";
    TestId["RIGHT_CONTAINER"] = "RIGHT_CONTAINER";
    TestId["CONTAINER_IMAGE"] = "CONTAINER_IMAGE";
    TestId["LIST_ITEM"] = "LIST_ITEM";
    TestId["CHECK_ICON"] = "CHECK_ICON";
    TestId["LOADING_LINE"] = "LOADING_LINE";
    TestId["OUTER_DIV"] = "OUTER_DIV";
})(TestId || (TestId = {}));
//# sourceMappingURL=TestId.js.map